import { SignIn } from "@clerk/react";
import HomeScreenBanner from "@/components/HomeScreenBanner";

export default function SignInPage() {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex relative items-end p-12 border-r border-[#262626]">
        <img
          src="https://images.unsplash.com/photo-1631744591853-998c4308bbb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxzZW1pJTIwdHJ1Y2slMjBvbiUyMGhpZ2h3YXl8ZW58MHx8fHwxNzkyODA5NDIzfDA&ixlib=rb-4.1.0&q=85"
          alt="Trucking"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="relative z-10 max-w-md">
          <div className="font-mono-label text-xs text-[#FFD600] mb-3">SIGN IN</div>
          <h2 className="font-heading font-black text-4xl leading-none mb-3">Resume your launch.</h2>
          <p className="text-muted-foreground">Pick up where you left off — filings, insurance, authority.</p>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center p-6" data-testid="sign-in-container">
        <div className="w-full max-w-md"><HomeScreenBanner /></div>
        <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
      </div>
    </div>
  );
}
